import(/* webpackMode: "eager" */ "/app/node_modules/@prismicio/next/dist/PrismicNextImage.cjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@prismicio/next/dist/PrismicPreviewClient.cjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@prismicio/next/dist/SliceSimulator.cjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["PageView"] */ "/app/src/app/brand/[slug]/PageView.tsx");
